import React from 'react';
import { withRouter } from "react-router";

import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';

// Images
import female_white from './images/female_white.png';
import female_blue from './images/female_blue.png';
import male_white from './images/male_white.png';
import male_blue from './images/male_blue.png';
// Images
import brandedSurveyLogo from './images/branded-survey-logo.png';
import surveyJunkieLogo from './images/survey-junkie-logo.png';
import surveyTimeLogo from './images/survey-time-logo.png';

class UserForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userForm: {
        email: '',
        firstname: '',
        lastname: '',
        isMale: null,
        password: '',
      },
      selectedAll: false,
      offers: [
        {
          name: 'BrandedSurvey',
          logo: brandedSurveyLogo,
          description1: 'Earn up to $5 per survey.',
          description2: 'Get paid in cash or gift cards.',
          description3: 'Gift cards from Amazon, iTunes More.',
          selected: false
        },
        {
          name: 'SurveyJunkie',
          logo: surveyJunkieLogo,
          description1: 'Earn up to $5 per survey.',
          description2: 'Get paid in cash or gift cards.',
          description3: 'Gift cards from Amazon, iTunes More.',
          selected: false
        },
        {
          name: 'SurveyTime',
          logo: surveyTimeLogo,
          description1: 'Earn up to $5 per survey.',
          description2: 'Get paid in cash or gift cards.',
          description3: 'Gift cards from Amazon, iTunes More.',
          selected: false
        },
      ],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event, v) {
    let userForm = this.state.userForm;
    userForm[v] = event.target.value;
    this.setState({ userForm });
  }

  setIsMale(b) {
    let userForm = this.state.userForm;
    userForm["isMale"] = b;
    this.setState({ userForm });
  }

  handleSubmit(event) {
    this.props.history.push({
      pathname: '/panel',
      state: this.state
    });
  }


  render() {
    return (
      <div className="signup-form">
        <Form onSubmit={this.handleSubmit}>
          <div className="signup-inner">
            <h4 className="border-bottom pb-3">Start earning <span>Today</span></h4>
            <h5 className="pt-2">Are you Male or Female?</h5>
            <Form.Group controlId="formBasicGender" className="text-center">
              <Row >
                <Col>
                  {this.state.userForm.isMale == null ?
                    <Image src={male_white} onMouseOver={e => (e.currentTarget.src = male_blue)} onMouseOut={e => (e.currentTarget.src = male_white)} onClick={(e) => this.setIsMale(true)} /> : this.state.userForm.isMale ?
                      <Image src={male_blue} /> :
                      <Image src={male_white} onMouseOver={e => (e.currentTarget.src = male_blue)} onMouseOut={e => (e.currentTarget.src = male_white)} onClick={(e) => this.setIsMale(true)} />}
                </Col>
                <Col>
                  {this.state.userForm.isMale == null || this.state.userForm.isMale ?
                    <Image src={female_white} onMouseOver={e => (e.currentTarget.src = female_blue)} onMouseOut={e => (e.currentTarget.src = female_white)} onClick={(e) => this.setIsMale(false)} /> : <Image src={female_blue} />}
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="formBasicEmail">
              <Form.Control type="email" placeholder="Enter email" value={this.state.userForm.email} onChange={(e) => this.handleChange(e, "email")} />
            </Form.Group>
            <Form.Group controlId="formBasicName">
              <Row>
                <Col>
                  <Form.Control type="text" placeholder="First name" firstname={this.state.userForm.firstname} onChange={(e) => this.handleChange(e, "firstname")} />
                </Col>
                <Col>
                  <Form.Control type="text" placeholder="Last name" lastname={this.state.userForm.lastname} onChange={(e) => this.handleChange(e, "lastname")} />
                </Col>
              </Row>
            </Form.Group>
            <Form.Group controlId="dob">
              <Form.Label>Date of birth</Form.Label>
              <Form.Control type="date" name="dob" placeholder="Date of Birth" />
            </Form.Group>
          </div>
          <Button className="btn btn-primary btn-block" variant="primary" type="submit">
            Get started
            </Button>
        </Form>
      </div>
    );
  }
}

export default withRouter(UserForm);